export interface ReplaceRule<T> {
  (input: string): T | undefined | false
}

export const replace = <T>(input: string, rules: ReplaceRule<T | T[]>[]): string | T | T[] => {
  for (const rule of rules) {
    const ruleResult = rule(input)
    if (ruleResult !== undefined && ruleResult !== false) {
      return ruleResult
    }
  }
  return input
}

export const replaceAll = <T>(input: string[], rules: ReplaceRule<T | T[]>[]) => {
  let result: Array<string | T> = []
  for (const str of input) {
    result = result.concat(replace(str, rules))
  }
  return result
}
